import { React } from 'react';

const Advertisement = ({ tableLoading, setTransectionData, transectionData }) => {
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({ ...prev, [name]: value }));
    };
    const handleCheckboxChange = (name) => (e) => {
        const checked = e.target.checked;
        setTransectionData((prev) => {
            const updated = { ...prev, [name]: checked };
            // Legacy quirk (not replicated here): the WinForms app never re-disabled
            // XML Feed once Publish had been checked at least once. We disable it again
            // whenever Publish is unchecked instead, which is the more correct behavior.
            if (name === 'publishStatus' && !checked) {
                updated.xmlFeed = false;
            }
            return updated;
        });
    };
    const charCount = transectionData?.marketingDesc ? transectionData.marketingDesc.length : '';

    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Publish this unit</label>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            style={{ width: '20px', height: '20px' }}
                            checked={!!transectionData?.publishStatus}
                            onChange={handleCheckboxChange('publishStatus')}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">XML Feed</label>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            style={{ width: '20px', height: '20px' }}
                            checked={!!transectionData?.xmlFeed}
                            disabled={!transectionData?.publishStatus}
                            onChange={handleCheckboxChange('xmlFeed')}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Open House</label>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            style={{ width: '20px', height: '20px' }}
                            checked={!!transectionData?.openHouse}
                            onChange={handleCheckboxChange('openHouse')}
                        />
                    </div>
                    <div className="d-flex" style={{ gridColumn: 'span 2' }}>
                        <label className="form-label pt-1 start">Marketing Description</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            value={transectionData?.marketingDesc || ''}
                            onChange={handleInputChange}
                            name="marketingDesc"
                        />
                        {charCount !== '' && <label className="form-label pt-1 mx-2">{charCount}</label>}
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Remarks 1</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.remarks1 || ''} onChange={handleInputChange} name="remarks1" />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Remarks 2</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.remarks2 || ''} onChange={handleInputChange} name="remarks2" />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Remarks 3</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.remarks3 || ''} onChange={handleInputChange} name="remarks3" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Advertisement;
